/* unplugin-vue-components disabled */import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import userConsentHtml from './user-consent.html?raw';
import privacyPolicyHtml from './privacy-policy.html?raw';
import dataBroadcastHtml from './data-broadcast.html?raw';
export default {
    __name: 'agreement',
    setup: function(__props) {
        // 导入本地 HTML 文件，?raw 表示以字符串形式导入
        var route = useRoute();
        var type = ref(route.query.type);
        var agreementContent = ref('Cargando...');
        var fetchAgreement = function() {
            switch(type.value){
                case '1':
                    agreementContent.value = userConsentHtml === null || userConsentHtml === void 0 ? void 0 : userConsentHtml.replace(/&nbsp;/g, ' ');
                    break;
                case '2':
                    agreementContent.value = privacyPolicyHtml === null || privacyPolicyHtml === void 0 ? void 0 : privacyPolicyHtml.replace(/&nbsp;/g, ' ');
                    break;
                case '4':
                    agreementContent.value = dataBroadcastHtml === null || dataBroadcastHtml === void 0 ? void 0 : dataBroadcastHtml.replace(/&nbsp;/g, ' ');
                    break;
                default:
                    agreementContent.value = 'Acuerdo no encontrado';
            }
        };
        fetchAgreement();
        return {
            __sfc: true,
            route: route,
            type: type,
            agreementContent: agreementContent,
            fetchAgreement: fetchAgreement
        };
    }
};
